import axios from 'axios';

export const signinUser = (data: any) =>
  axios.post('/api/v1/auth/signin', data);

export const getUserInfo = () => axios.get('/api/v1/auth/me');

export const forgotPassword = (data: any) =>
  axios.post('/api/v1/auth/forgot-password', data);
